import { render } from "./industry-ranking-table.vue?vue&type=template&id=07379d82&scoped=true"
import script from "./industry-ranking-table.vue?vue&type=script&lang=ts"
export * from "./industry-ranking-table.vue?vue&type=script&lang=ts"

import "./industry-ranking-table.vue?vue&type=style&index=0&id=07379d82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07379d82"

export default script